import { render, staticRenderFns } from "./BatteryData.vue?vue&type=template&id=64ebe742&scoped=true&"
import script from "./BatteryData.vue?vue&type=script&lang=ts&"
export * from "./BatteryData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ebe742",
  null
  
)

export default component.exports